module.exports = __webpack_public_path__ + "static/media/julia.d1e0902a.jpg";